import React from 'react';
import PlatformDownloaderLinks from './PlatformDownloaderLinks';

export default function HowToDownloadYouTubeVideos() {
  const styles = {
    container: {
      padding: '20px',
      maxWidth: '768px',
      margin: '0 auto',
    },
    heading: {
      fontSize: '24px',
      textAlign: 'center',
      marginBottom: '16px',
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '16px',
    },
    image: {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: '8px',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>How to Download YouTube Videos</h1>

      <p style={{ background: '#eef4ff', border: '1px solid #c7d8ff', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px' }}>
        <strong>Want HD quality? Use our <a href="https://downloadermedia.com/" target="_blank" rel="noopener noreferrer">Chrome extension</a> to download YouTube videos in HD quality.</strong>
      </p>

      <p>1. Open YouTube and copy the link of the video you want to download.</p>

      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/ZRMdRqCM/image.png" 
          alt="copy youtube link"
          style={styles.image}
        />
      </div>

      <br/> <br/>
      <p> If you're looking for High Resolution downloads > 360p, and if you're on desktop device, skip to Step 6 </p>

      <p>2. Open your browser and go to <strong>downr.org</strong>.</p>

      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/L6qrhQ0D/image.png" 
          alt="downr homepage"
          style={styles.image}
        />
      </div>

      <br/><br/>
      <p>3. Paste the YouTube link into the input box and click the Download button.</p>

      <br/><br/>
      <p>4. Wait a few seconds while the Downr processes your video. Then, Choose your preferred format and quality</p>

      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/wjgZFxjW/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>
      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/RF7wPmFg/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>

      <br/><br/>
      <p>5. Click the download link. On mobile, you may need to press and hold, then select <strong>"Download Linked File"</strong>.</p>
      <p>Download guide for Android -> <a href="/how-to-download-android" target="_blank">How to Download Media in Android</a></p>
      <p>Download guide for iOS -> <a href="/how-to-download-ios" target="_blank">How to Download Media in iOS</a></p>

      <PlatformDownloaderLinks first="youtube" />
 
      <br/> <br/>
      <p>6. High Definition downloads are currently restricted to <a href="/extension" target="_blank">Downr Chrome Extension</a>. Downr Chrome Extension is free to use, user friendly and trusted by more than 30000 active users. Our Chrome extension supports several platforms on top of YouTube, however, we highly recommend to use Downr website for social platforms other than YouTube.</p>

      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/5NzdtkXX/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>  

      <br/> <br/>
      <p>7. Click on <strong>"Add To Chrome"</strong> and install the CRX Launch extension from chrome webstore</p>

      <br/> <br/>
      <p>8. You need to provide browser permissions to inspect urls so that Downr extension will be able to understand once a video page is loaded. Note that we <a href="/privacy-policy" target="_blank">DO NOT harvest users' data</a>  in any manner and these permissions are for our extension to work properly. Our extension does support many more platforms other than YouTube. Click on <strong>"Allow permissions"</strong> and Click on <strong>"Allow"</strong> </p>

      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/gk3hKmxt/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>  
      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/t42YrTpZ/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>
      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/DzLRvW0s/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>

      <br/> <br/>
      <p>9. Open the extension on your Chrome browser when you're on the designated YouTube video page. You should see something like this.</p>
      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/3wyYgj1g/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>

      <br/> <br/>
      <p>10. Select the video resolution and Click on Download button. Now the process is started and you can switch to processing page. Wait till it is completed. It can stake some tiem depending on the video resolution and length.</p>
      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/6pm9Pb1p/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>

      <br/> <br/>
      <p>10. Once the processing is completed, the download button will be visible and you can click on <strong>Download</strong> to download the video into your device. </p>
      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/KjRf0zKf/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>
      <div style={styles.imageContainer}>
        <img 
          src="https://i.postimg.cc/VkLv8K1j/image.png" 
          alt="download options"
          style={styles.image}
        />
      </div>


    </div>
  );
}